module.exports = function(macrosites) {
	'use strict'
	macrosites.directive('macrositesFocusNewsDir',macrositesFocusNewsDir);
	macrositesFocusNewsDir.$inject=[];
	function macrositesFocusNewsDir() {
		return {
			template: require('./partial/macrositesFocusNews.html'),
			controller:'macrositesFocusNewsController',
			controllerAs:'vmmfn',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/macrositesModule/focusNews/js/directive/macrositesFocusNewsDirective.js
// module id = 510
// module chunks = 0